import { render, staticRenderFns } from "./TruckTracking.vue?vue&type=template&id=23d7820d&scoped=true&"
import script from "./TruckTracking.vue?vue&type=script&lang=js&"
export * from "./TruckTracking.vue?vue&type=script&lang=js&"
import style0 from "./TruckTracking.vue?vue&type=style&index=0&id=23d7820d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7820d",
  null
  
)

export default component.exports